module.exports = __webpack_public_path__ + "img/statistics_filled_32.b36b0ce2.svg";